<template>
	<div>
		<el-card>
			<div slot="header" style="font-weight: bolder;float: left;font-size: 24px;text-align: left;">{{$t('lang.lab_borrowingRecord')}}</div>
			<el-button type="primary" slot="header" @click="back">返回</el-button>
			<!-- <el-button type="primary" slot="header">{{$t('lang.btn_addBorrowing')}}</el-button> -->
			<!-- 物品借用记录表格 -->
			<el-table :data="borrowingRecordList" class="wid100" :height="borrowingRecordList.length > 0 ? 675 : 109">
				<el-table-column prop="id" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="borrowingName" :label="$t('lang.lab_borrowingName')"></el-table-column>
				<el-table-column prop="nickName" :label="$t('lang.lab_userNickName')"></el-table-column>
				<el-table-column prop="userName" :label="$t('lang.lab_borrowingUserName')"></el-table-column>
				<el-table-column prop="borrowingInfo" :label="$t('lang.lab_borrowingInfo')"></el-table-column>
				<el-table-column prop="returnInfo" :label="$t('lang.lab_returnInfo')"></el-table-column>
				<el-table-column prop="createTime" :label="$t('lang.lab_borrowingCreateTime')">
					<template slot-scope="scope">
						{{scope.row.createTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="planReturnTime" :label="$t('lang.lab_planReturnTime')">
					<template slot-scope="scope">
						{{scope.row.planReturnTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="returnTime" :label="$t('lang.lab_returnTime')">
					<template slot-scope="scope">
						{{scope.row.returnTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="state" :label="$t('lang.lab_borrowingState')">
					<template slot-scope="scope">
						<span v-if="scope.row.state == 0" style="color: red;">借出中</span>
						<span v-if="scope.row.state == 1" style="color: #34CE57;">已归还</span>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
				:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pageNo: 1,
				pageSize: 10,
				pageCount: 0,
				borrowingId: '',
				borrowingRecordList: []
			}
		},
		created() {
			// console.log(this.$route.query.borrowingId)
			this.borrowingId = this.$route.query.borrowingId
			this.selectList()
		},
		methods: {
			back() {
				this.$router.push({
          name: 'borrowingManager'
        })
			},
			selectList() {
				let loading = this.$loading()
				let param = {
					borrowingId: this.borrowingId,
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}
				this.$get(`/borrowingRecord`, param)
					.then(res => {
						// setTimeout(() => {
						this.borrowingRecordList = res.list
						this.pageCount = res.pageCount
						loading.close()
						// console.log(res)
						// }, 1000)
					})
					.catch(err => {
						console.log(err)
					})
			},
			// 点击换页
			handleCurrentChange(val) {
				this.pageNo = val
				this.selectList()
			},
			// 点击更改每页容量
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.selectList()
			}
		}
	}
</script>

<style scoped>

</style>
